import React, { useEffect, useState } from "react";
import { messageError, messageSuccess } from '../../toastr'
import { Col, Form, InputNumber, Input, Select, Switch, Modal, Typography } from "antd";
import CmdService from "../../../app/service/cmdService";
import { Button } from "../../button";
import { Button as ButtonsANTD } from 'antd';
import { deviceStatusFields, deviceStatusToFields, modalConfirm } from "../utils/configurations";
import { SaveOutlined } from '@ant-design/icons';
const { Text } = Typography;
const { Option } = Select;

export const DeviceConfigurations = ({ plateName, deviceStatus, save, routeStartStatus }) => {
    const [formDeviceConfig] = Form.useForm();
    const serviceCmd = new CmdService();
    const [visible, setVisible] = useState(false);
    const [visibleTimeStopControl, setVisibleTimeStopControl] = useState(false);
    const [visibleSensityJamming, setVisibleSensityJamming] = useState(false);
    const [visibleBlocks, setVisibleBlocks] = useState(false);

    const setDeviceConfig = () => {
        deviceStatus && formDeviceConfig.setFieldsValue(deviceStatusToFields(deviceStatus));
        setVisible(formDeviceConfig.getFieldValue("bloqueioTipo") === "progressivo" ? false : true);
        setVisibleSensityJamming(formDeviceConfig.getFieldValue("jamming") ? false : true);
        setVisibleBlocks(formDeviceConfig.getFieldValue("bloqueadorEmbutido") ? false : true);
        setVisibleTimeStopControl(formDeviceConfig.getFieldValue("controleParada") ? false : true)
    };

    const sendDeviceConfiguration = () => {

        const dataForm = deviceStatusFields(plateName, formDeviceConfig, deviceStatus);
        if (dataForm.roteirizador === 0 && routeStartStatus === "STARTED") {
            dataForm.nameCommands = "";
            Modal.confirm({
                title: "ATENÇÃO! Dispositivo em rota.",
                content: "Este veículo encontra-se com roteirização em curso, e esta ação cancelará tal processo. Deseja realmente prosseguir?",
                okText: "Confirmar",
                cancelText: "Cancelar",
                onOk: () => handleSendCmdDevicesStatus(dataForm),
            });
        } else {
            sendCmdDeviceStatus(dataForm);

        }


    }

    const sendCmdDeviceStatus = (data) => {

        data.nameCommands = "";
        data.nameCommands = compareStatus(data, deviceStatus, data);
        save();
        serviceCmd
            .sendCmdDeviceStatus(data)
            .then(response => {
                if (response.data.status !== 200) {
                    messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
                } else {
                    messageSuccess("Comando transmitido. Aguarde a confirmação de efetivação.");
                }
            })
            .catch(erros => {
                if (erros.response.status === 400) {
                    messageError(erros.response.data.message);
                } else {
                    messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
                }
            });

    };

    const handleSendCmdDevicesStatus = (dataForm) => {
        save();
        dataForm.nameCommands = "";
        dataForm.nameCommands = compareStatus(dataForm, deviceStatus, dataForm);
        serviceCmd
            .sendCmdDeviceStatus(dataForm)
            .then(response => {
                if (response.data.status !== 200) {
                    messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
                } else {
                    messageSuccess("Comando transmitido. Aguarde a confirmação de efetivação.");
                }
            })
            .catch(erros => {
                if (erros.response.status === 400) {
                    messageError(erros.response.data.message);
                } else {
                    messageError("ERRO! Falha no processamento desta ação, favor repetir o processo.");
                }
            });

        const data = {
            plate: plateName,
        }

        serviceCmd.sendRoute(data, "stop").then((response) => {
            if (response.data.status === 200) {
                //messageSuccess("Comando de finalizar rota enviado.");
            } else {
                //messageError("Error ao enviar comando de finalizar rota.");
            }
        }).catch((error) => {
            console.error("Error", error);
        });
    }

    const bloqueioProgressivo = () => {
        setVisible(true);
    }
    const desbloqueioProgressivo = () => {
        setVisible(false);
    }
    const confirmBloqueioProgressivo = () => {
        modalConfirm(formDeviceConfig, bloqueioProgressivo, desbloqueioProgressivo);
    }

    const bloqueioSeguro = () => {
        setVisible(true);
    }

    const compareStatus = (data, actualStatus, posStatus) => {
        if (actualStatus.bloqueador !== posStatus.bloqueador) {
            data.nameCommands += `${posStatus.bloqueador === 0 ? "Desativado" : "Ativando"} bloqueador\n`
        }
        if (actualStatus.controleParada !== posStatus.controleParada) {
            data.nameCommands += `${posStatus.controleParada === 0 ? "Desativado" : "Ativando"} bloqueio por controle de parada\n`
        }
        if (actualStatus.jamming[0] !== posStatus.jamming[0]) {
            data.nameCommands += `${posStatus.jamming[0] === "0" ? "Desativado" : "Ativando"}  bloqueio por detecção de jamming\n`
        }
        if (actualStatus.idRastreador !== posStatus.idRastreador) {
            data.nameCommands += `${posStatus.idRastreador === 0 ? "Desativado" : "Ativando"} bloqueio por diferença de ID\n`
        }
        if (actualStatus.faltaStt !== posStatus.faltaStt) {
            data.nameCommands += `${posStatus.faltaStt === 0 ? "Desativado" : "Ativando"} bloqueio por remoção do rastreador\n`
        }
        if (actualStatus.jamming.substring(1, 3) !== posStatus.jamming.substring(1, 3)) {
            data.nameCommands += `Alterado sensibilidade jamming de ${actualStatus.jamming.substring(1, 3)} para ${posStatus.jamming.substring(1, 3)}\n`
        }
        if (actualStatus.remSimcard !== posStatus.remSimcard) {
            data.nameCommands += `${posStatus.remSimcard === 0 ? "Desativado" : "Ativando"} bloqueio por remoção do chip\n`
        }
        if (actualStatus.tipoBlk !== posStatus.tipoBlk) {
            data.nameCommands += `Alterando tipo de bloqueio para ${posStatus.tipoBlk === 0 ? "Seguro" : "Progressivo"}\n`
        }
        if (actualStatus.roteirizador[0] !== posStatus.roteirizador.toString()) {
            data.nameCommands += `${posStatus.roteirizador === 0 ? "Desativado" : "Ativando"} roteirizador\n`
        }
        if (actualStatus.senhaIgnicao.toString() !== posStatus.senhaIgnicao) {
            data.nameCommands += `Alterando senha ignição de ${actualStatus.senhaIgnicao} para ${posStatus.senhaIgnicao}\n`
        }
        if (actualStatus.tempoParada / 10 !== posStatus.tempoParada / 10) {
            data.nameCommands += `Alterando tempo de parada de ${actualStatus.tempoParada / 10} para ${posStatus.tempoParada / 10}\n`
        }
        if (actualStatus.tempoPresenca / 10 !== posStatus.tempoPresenca / 10) {
            data.nameCommands += `Alterando tempo para bloquear de ${actualStatus.tempoPresenca / 10} para ${posStatus.tempoPresenca / 10}\n`
        }

        return data.nameCommands;
    }

    useEffect(() => {
        setDeviceConfig();
    }, []);


    return (
        <Form form={formDeviceConfig} style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }} wrapperCol={{
            span: 15,
        }} labelCol={{
            span: 13,
        }}>

            <Col span={11} style={{ marginTop: '0px' }}>
                <Form.Item name="roteirizador" label="ROTEIRIZADOR" valuePropName="checked" style={{ height: '20px', marginTop: '10px' }}>
                    <Switch checkedChildren="ON" unCheckedChildren="OFF" />
                </Form.Item>
            </Col>
            <Col span={11}>

            </Col>
            <Col span={11}>
                <Form.Item name="controleParada" label="Controle de Parada" style={{ height: '20px' }} valuePropName="checked">
                    <Switch checkedChildren="ON" unCheckedChildren="OFF" />
                </Form.Item>
            </Col>
            <Col span={11} offset={1}>
                <Form.Item name="controleParadaTempo" label="Tempo de Parada" dependencies={['controleParada']} rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!getFieldValue('controleParada')) {
                                return setVisibleTimeStopControl(true);
                            } else {
                                return setVisibleTimeStopControl(false);
                            }



                        },
                    }),
                ]}>
                    <InputNumber
                        min={1}
                        max={9.5}
                        step={1}
                        formatter={value => visibleTimeStopControl ? "" : `${value} min`}
                        parser={value => value.replace('min', '')}
                        disabled={visibleTimeStopControl}
                        width={'100%'}
                    />
                </Form.Item>
            </Col>

            <Col span={11} style={{ marginTop: '10px' }}>
                <Form.Item name="bloqueadorEmbutido" label="BLOQUEADOR" valuePropName="checked" style={{ color: 'red' }} >
                    <Switch checkedChildren="ON" unCheckedChildren="OFF" />
                </Form.Item>
            </Col>
            <Col span={11} offset={1} style={{ marginTop: '10px' }}>
            </Col>

            <Col span={11} style={{ marginTop: '-30px' }}>
                <Form.Item name="bloqueioTipo" label="Tipo de Bloqueio" style={{ height: '20px' }} dependencies={['bloqueadorEmbutido']} rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!getFieldValue('bloqueadorEmbutido')) {
                                return setVisibleBlocks(true);
                            } else {
                                return setVisibleBlocks(false);
                            }



                        },
                    }),
                ]}>
                    {visibleBlocks ?
                        <ButtonsANTD disabled block style={{ width: '90%' }}>
                        </ButtonsANTD>
                        :
                        <Select onChange={(option) => option === "progressivo" && confirmBloqueioProgressivo() || option === "seguro" && bloqueioSeguro()} placeholder="Tipo de Bloqueio" style={{ width: '90%' }} disabled={visibleBlocks}>
                            <Option value="seguro">Seguro</Option>
                            <Option value="progressivo">Progressivo</Option>
                        </Select>}

                </Form.Item>
                <Form.Item name="bloqueioTempo" label="Tempo para Bloqueio" style={{ height: '20px' }}>
                    <InputNumber
                        min={1}
                        max={9.5}
                        step={0.5}
                        formatter={value => visible || visibleBlocks ? "" : `${value} min`}
                        parser={value => value.replace('min', '')}
                        style={{ width: '90%' }}
                        disabled={visible || visibleBlocks}
                    />
                </Form.Item>
            </Col>
            <Col span={11} offset={1} style={{ marginTop: '-40px' }}>
                <Form.Item label="Senha de ignição" style={{ height: '20px', marginTop: '10px' }}>
                    <Form.Item name="senhaIgnicaoInput1" noStyle>
                        <InputNumber
                            min={1}
                            max={9}
                            step={1}
                            style={{ width: '50%' }}

                        />

                    </Form.Item>
                    <Form.Item name="senhaIgnicaoInput2" noStyle>
                        <InputNumber
                            min={1}
                            max={9}
                            step={1}
                            style={{ width: '50%' }}
                        />
                    </Form.Item>
                </Form.Item>
                <Form.Item name="sensiJamming" label="Sensibilidade a Jamming" dependencies={['jamming']} rules={[
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!getFieldValue('jamming')) {
                                return setVisibleSensityJamming(true);
                            } else {
                                return setVisibleSensityJamming(false);
                            }
                        },
                    }),

                ]}>
                    <InputNumber
                        min={10}
                        max={90}
                        step={5}
                        formatter={value => visibleSensityJamming ? "" : `${value} %`}
                        parser={value => value.replace('%', '')}
                        style={{ width: '100%' }}
                        disabled={visibleSensityJamming}
                    />
                </Form.Item>
            </Col>



            <Col span={24} style={{ marginTop: '20px', marginLeft: '70px' }}>
                <Text level={5}>{visibleBlocks ? "Detecção de:" : "Bloqueio por:"} </Text>
            </Col>

            <Col span={11}>
                <Form.Item name="bloqueioID" label="Diferença de ID" style={{ height: '5px' }} valuePropName="checked">
                    <Switch checkedChildren="ON" unCheckedChildren="OFF" />
                </Form.Item>
                <Form.Item name="bloqueioRemocaoSimCard" label="Remoção do Chip" style={{ height: '5px' }} valuePropName="checked">
                    <Switch checkedChildren="ON" unCheckedChildren="OFF" />
                </Form.Item>
            </Col>
            <Col span={11} offset={1}>

                <Form.Item name="bloqueioRemocaoRastreador" label="Remoção Rastreador" style={{ height: '5px' }} valuePropName="checked">
                    <Switch checkedChildren="ON" unCheckedChildren="OFF" />
                </Form.Item>
                <Form.Item name="jamming" label="Detecção de Jamming" style={{ height: '5px' }} valuePropName="checked">
                    <Switch checkedChildren="ON" unCheckedChildren="OFF" />
                </Form.Item>
            </Col>



            <Col span={24}>
                <Button
                    className={"successButton"}
                    icon={<SaveOutlined />}
                    style={{ marginTop: '30px', marginLeft: "88%", width: '15%' }}
                    type="primary"
                    shape="round"
                    onClick={() => sendDeviceConfiguration()}
                    children="Salvar"
                />
            </Col>
        </Form>
    );
}